/**
 * NIVARO · home / landing helpers.
 * - Landing "Producto estrella": thumbnail gallery + size radios that set the
 *   variant on the CTA. The actual add-to-cart is the global
 *   [data-nv-add-variant] handler in nivaro-ui.js (window.NV.addToCart).
 */

function initLandingProduct(root) {
  if (root.dataset.nvReady) return;
  root.dataset.nvReady = 'true';

  const slides = root.querySelectorAll('[data-nv-lpp-slide]');
  const thumbs = root.querySelectorAll('[data-nv-lpp-thumb]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = thumb.getAttribute('data-nv-lpp-thumb');
      slides.forEach((slide) => {
        slide.hidden = slide.getAttribute('data-nv-lpp-slide') !== index;
      });
      thumbs.forEach((t) => {
        const active = t === thumb;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', String(active));
      });
    });
  });

  const button = root.querySelector('[data-nv-lpp-add]');
  const hint = root.querySelector('[data-nv-lpp-hint]');
  if (!button) return;

  root.querySelectorAll('[data-nv-lpp-size]').forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      button.setAttribute('data-nv-add-variant', input.value);
      if (hint) hint.hidden = true;
    });
  });

  // No size chosen yet: ask for one instead of silently doing nothing.
  button.addEventListener('click', () => {
    if (button.hasAttribute('data-nv-add-variant')) return;
    if (hint) hint.hidden = false;
    root.querySelector('[data-nv-lpp-size]:not([disabled])')?.focus();
  });
}

function init() {
  document.querySelectorAll('[data-nv-lpp]').forEach(initLandingProduct);
}

init();
document.addEventListener('shopify:section:load', init);
